import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ViewChildren, QueryList, OnDestroy, HostListener } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { forkJoin, Subject, timer } from 'rxjs';
import { TimesheetsService } from 'src/app/manageprofile/Timesheet.service';
import { KC_MATERIAL_DATE_FORMATS } from 'src/app/Models/materialDatepickerConfig';
import { MaskedDateTimeService, TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { ToastrService } from 'ngx-toastr';
import { NgSelectModule } from '@ng-select/ng-select';
import { EventService } from 'src/app/shared/event.service';
import { CommonEvents, warningPopResponse } from 'src/app/shared/app.constant';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { KcWarningPopupComponent } from '../kc-warning-popup/kc-warning-popup.component';
import { ClientService } from 'src/app/client/client.service';
import { FirmDetailService } from 'src/app/settings/firm-details/firm-detail.service';
import { LogTimeService } from 'src/app/shared/logtime.service';
import { takeUntil } from 'rxjs/operators';
import { UserManagementService } from '../../userManagement.service';
import { canShowEditDeleteContainer as canShowEditDeleteContainerUtil } from 'src/app/utility/helper-function.utils';

@Component({
  selector: 'app-quick-timesheet-entry-popup',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatTooltipModule, NgSelectModule, TimePickerModule],
  templateUrl: './quick-timesheet-entry-popup.component.html',
  styleUrls: ['./quick-timesheet-entry-popup.component.scss'],
  providers: [MaskedDateTimeService,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: KC_MATERIAL_DATE_FORMATS }],
})

export class QuickTimesheetEntryPopupComponent implements OnInit, OnDestroy {
  @Output() closeQuickAddTimesheetEntryPopup = new EventEmitter();
  @ViewChild('clientDropdown', { static: false }) clientDropdown!: any;
  @ViewChild('jobDropdown', { static: false }) jobDropdown!: any;
  @ViewChild('taskDropdown', { static: false }) taskDropdown!: any;
  @ViewChildren('unitquicktime') unitquicktime: QueryList<ElementRef>;
  @ViewChildren('quicktime') quicktime: QueryList<ElementRef>;
  @ViewChildren('descpquicktime') descpquicktime: QueryList<ElementRef>;
  @Input() loggedData: any[] = [];
  @Input() selectedDataAlt: any;
  @Input() timesheetClientList: any;
  @Input() sourceComponent: string;
  @Input() TimeSheetlevel: any;
  @Input() preparedMultiCellSelectedObj: any;
  @Input() timesheetFormat: any;
  @Input() selectedJobId: any;
  @Input() resData: any[];
  @Input() selectedMonthHolidays: any[];
  @Input() isHoliday: any;
  @Input() _tempUnitVal: number;
  @Input() shouldPopulateMultiCellFields: boolean = false;
  @Input() UserId: any;
  @Input() timesheetName: string;
  public quickAddTimesheetClientList: { [key: string]: Object }[] = [];
  quickAddSelectedTimesheetClient: any;
  selectedTimesheetJob: any;
  quickAddSelectedTimesheetClientID: number;
  timesheetJobList: { [key: string]: Object }[] = [];
  timesheetTaskList: { [key: string]: Object }[] = [];
  timePickerMaskPlaceholderValue: Object = { hour: 'hh', minute: 'mm' }
  selectedTimesheetClientID: number;
  timesheetdatePickerdefault: Date;
  selectedTimesheetJobID: number;
  selectedTimesheetTask: any;
  isJobDropdownDisabled: boolean = true;
  isTaskDropdownDisabled: boolean = true;
  selectedTimesheetTaskID: any;
  _timeSheetFormat: boolean = false;
  _timeSheetUnitVal: number = 0;
  _timeSheetlevel: boolean;
  rateListData: Array<BillRatesValues> = [];
  userDefaultRate: any;
  userId: any;
  selectedDefaultRate: any;
  selectedUnitValue: number | null = null;
  calculatedTime: string | null = '';
  _timesheetpracticwesetting: any;
  startDate: string;
  startDateTime: any;
  isFieldsEnabled: boolean = false;
  selectedContextId: number;
  selectedlogTimeId: number;
  selectedComment: string;
  selectedClientId: number;
  isTimeFieldEnabled: boolean = false;
  isRateFieldEnabled: boolean = false;
  isClientDisabled: boolean = false;
  isUnitFieldsEnabled: boolean = false;
  isStartTimeFieldsEnabled: boolean = false;
  isDateFieldsEnabled: boolean = false;
  isCommentFieldsEnabled: boolean = false;
  public warningPopupRes = warningPopResponse;
  originalSelectedTimesheetClient: number;
  originalSelectedTimesheetJob: number;
  originalSelectedTimesheetTask: number;
  originalTimesheetDatePicker: Date;
  originalStartDateTime: Date;
  originalSelectedUnitValue: number;
  originalSelectedDefaultRate: number;
  originalCalculatedTime: string;
  originalComment: string;
  clientIdAlt: number;
  disableAddButton: boolean = false;
  dropdownItemList: any[] = [];
  quickAddClientList: any[] = [];
  quickAddNonBillableList: any[] = [];
  isAltShortcutActive: boolean = false;
  isFutureDate: boolean = false;
  hasUnsavedChanges: boolean = false;
  lstDailyLogData: any[] = [];
  commentlist: any[] = [];
  maxHoursPerDay: number = 8;
  selectedContextIdForleave: any;
  private unsubscribe = new Subject<void>();
  public bsModalRef: BsModalRef;
  isUserAllowedToLog: boolean = true;
  allRates: any[] = [];
  dailyLogTimeContextId: number;

  constructor(private _timesheetService: TimesheetsService, private _toastr: ToastrService, private datepipe: DatePipe, private currencyPipe: CurrencyPipe, private eventService: EventService, public modalService: BsModalService, private clientService: ClientService, private firmDetailService: FirmDetailService, private logtimeService: LogTimeService, private userManagementService: UserManagementService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.resData || this.selectedMonthHolidays) {
      //perform whatever action needed
    }
    if (changes.selectedMonthHolidays && this.timesheetdatePickerdefault) {
      this.updateHolidayFlag(this.timesheetdatePickerdefault);
    }
  if (changes.timesheetClientList && this.sourceComponent !== 'NewTimesheetComponent') {
      this.getClientListData();
    }
    if (changes.selectedDataAlt && this.sourceComponent === 'NewTimesheetComponent') {
      this.setDropdownItemListBasedOnContext();
    }
    if (changes['selectedDataAlt']?.currentValue) {
      let newValue = changes['selectedDataAlt']?.currentValue;
      this.selectedDataAlt = {
        ...newValue,
        startDateTime: newValue?.startDateTime ?? newValue?.StartTime,
        endDateTime: newValue?.endDateTime ?? newValue?.EndTime,
      }
    }

  }
  ngOnInit(): void {
    this.clientIdAlt = Number(localStorage.getItem("clientid"));
    this.userId = localStorage.getItem("Userid").toString();
    if (this.sourceComponent === 'NewTimesheetComponent') {
      this.getClientListData();
    } else if (this.sourceComponent === 'headerComponent') {
      this.getClientListDataAlt();
    }
    this.timesheetdatePickerdefault = new Date();
    this.GetPracticeTimesheetdeatil();
    if (this.sourceComponent == 'others' || this.sourceComponent == 'headerComponent') {
      this.GetDailyTimeSheetData();
    }
    this.handleSelectedDataAltLogic();
    this.Getuser();
    this.calculateDurationSum();

    this.selectedDataAlt = {
      ...this.selectedDataAlt,
      startDateTime: this.selectedDataAlt?.startDateTime ?? this.selectedDataAlt?.StartTime,
      endDateTime: this.selectedDataAlt?.endDateTime ?? this.selectedDataAlt?.EndTime,
    }  

    if (this.selectedDataAlt?.startDateTime) {
      const currentSystemTime = new Date();
      this.timesheetdatePickerdefault = new Date(
        this.selectedDataAlt?.startDateTime?.getFullYear(),
        this.selectedDataAlt?.startDateTime?.getMonth(),
        this.selectedDataAlt?.startDateTime?.getDate(),
        currentSystemTime.getHours(),
        currentSystemTime.getMinutes(),
        currentSystemTime.getSeconds()
      );
    }

    this.getListOfMonthHolidays(this.timesheetdatePickerdefault);

    if (this.shouldPopulateMultiCellFields && this.selectedDataAlt?.clientId == undefined) {
      this.popuplateMultipleCellSelectedFields();
    }
    if (this.isTaskCategoryRateDisabled(this.selectedDataAlt?.taskCategory)) {
      this.disableRate = true;
      this.selectedDefaultRate = 0;
    }
  }

  handleSelectedDataAltLogic(): void {
    if (!this.selectedDataAlt) return;

    if (this.selectedDataAlt.context === 'MastertimesheetId') {
      this.isTimeFieldEnabled = !this.timesheetFormat;
      this.populateLeaveFields();
    } else {
      this.selectedContextId = this.selectedDataAlt?.jobId || this.selectedDataAlt?.jobid ||
        this.selectedDataAlt?.JobId || this.resData?.[0]?.jobId;
      this.selectedClientId = this.selectedDataAlt?.clientId || this.selectedDataAlt?.ClientId || this.clientIdAlt;
      this.getJobsAndTaskForSelectedClient();
    }

    if (this.sourceComponent === 'others' &&
      (!this.selectedDataAlt.clientId || this.selectedDataAlt.clientId === 0)) {
      this.selectedClientId = this.clientIdAlt;
      this.selectedContextId = this.selectedDataAlt?.jobId || this.selectedDataAlt?.jobid ||
        this.selectedDataAlt?.JobId || this.selectedJobId;
      this.getJobsAndTaskForSelectedClient();
    }
  }

  populateLeaveFields() {
    this.originalSelectedTimesheetClient = this.quickAddSelectedTimesheetClient;
    this.originalSelectedTimesheetJob = null;
    this.originalSelectedTimesheetTask = null;
    this.originalTimesheetDatePicker = this.timesheetdatePickerdefault || new Date();
    this.originalStartDateTime = this.startDateTime || new Date();
    this.originalSelectedUnitValue = this.selectedUnitValue || null;
    this.originalSelectedDefaultRate = this.selectedDefaultRate;
    this.originalCalculatedTime = this.calculatedTime || '';
    this.originalComment = this.selectedComment || '';

    this.populateFormFields();
  }

  populateFormFields() {
    if (this.selectedDataAlt || this.selectedDataAlt.clientId === 0 || this.resData[0]) {
      const fieldsToMap = [
        { target: 'selectedTimesheetJob', source: 'jobId', altSource: 'jobid', altSource2: 'JobId' },
        { target: 'selectedTimesheetTask', source: 'taskId', altSource: 'id' },
        { target: 'timesheetdatePickerdefault', source: 'startDateTime' },
        { target: 'startDateTime', source: 'startDateTime' },
        { target: 'selectedUnitValue', source: 'unit' },
        { target: 'selectedDefaultRate', source: 'finalRate' },
        { target: 'calculatedTime', source: 'durationStr' }
      ];
      if (this.selectedDataAlt?.clientId !== 0) {
        const clientCode = this.selectedDataAlt.clientCode ?? this.selectedDataAlt.ClientCode ?? '';
        const clientName = this.selectedDataAlt.clientName ?? this.selectedDataAlt.ClientName ?? '';

        this.quickAddSelectedTimesheetClient = clientCode && clientName
           ? `${clientName} (${clientCode})`
          : clientCode || clientName;
        this.originalSelectedTimesheetClient = this.quickAddSelectedTimesheetClient;
        this.selectedTimesheetClientID = this.selectedDataAlt.clientId;
      } else {
        if (this.selectedDataAlt.context == 'MastertimesheetId') {
         this.quickAddSelectedTimesheetClient = this.selectedDataAlt.name;
         // Set selectedContextIdForleave for non-billable entries when editing
         this.selectedContextIdForleave = this.selectedDataAlt.contextId || this.selectedDataAlt.mastertimesheetId;
         this.selectedTimesheetClientID = 0;
        } else {
          const clientCode = this.selectedDataAlt.clientCode ?? this.selectedDataAlt.ClientCode ?? '';
          const clientName = this.selectedDataAlt.clientName ?? this.selectedDataAlt.ClientName ?? '';

          this.quickAddSelectedTimesheetClient = clientCode && clientName
           ? `${clientName} (${clientCode})`
            : clientCode || clientName;
          this.originalSelectedTimesheetClient = this.quickAddSelectedTimesheetClient;
          this.selectedTimesheetClientID = 0;
        }
      }
      if (this.sourceComponent == 'others' && this.resData) {
        const clientCode = this.resData[0].clientCode ?? this.resData[0].ClientCode ?? '';
        const clientName = this.resData[0].clientName ?? this.resData[0].ClientName ?? '';
       this.quickAddSelectedTimesheetClient = `${clientName} (${clientCode})`;
        this.selectedUnitValue = null;
      }
      fieldsToMap.forEach(field => {
        if (this.sourceComponent === 'others' && field.target === 'selectedUnitValue') {
          return;
        }
        const value = this.selectedDataAlt[field.source] ?? this.selectedDataAlt[field.altSource] ?? this.selectedDataAlt[field.altSource2] ?? (this.resData[0] ? this.resData[0][field.source] : undefined);
        if (field.target === 'selectedTimesheetJob' && value && !this.timesheetJobList.some(job => job.jobId === value)) {
          const jobCode = this.selectedDataAlt.jobCode ?? "";
          const jobName = this.selectedDataAlt.jobName ?? "";
          const displayJobName = jobCode ? `${jobCode}${jobName ? ' - ' + jobName : ''}` : jobName;
          this.timesheetJobList.push({
            jobId: value,
            displayJobName,
            jobCode,
            jobName,
            disabled: false
          })
        }
        this[field.target] = value;
        this[`original${this.capitalize(field.target)}`] = value;
      });

      this.selectedComment = this.selectedDataAlt.comment;
      this.originalComment = "";
    }
    if (this.selectedDataAlt) {
      this.applyRateRuleForTaskCategory(this.selectedDataAlt?.taskCategory, this.selectedDefaultRate);
    }
  }

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  enablingFields() {
    if (this.sourceComponent === 'NewTimesheetComponent' && (this.selectedDataAlt?.clientId || this.selectedDataAlt.clientId === 0)) {
      const validStatusIds = [1, 2, 3, 4, 5];
      if (validStatusIds.includes(this.selectedDataAlt.statusId)) {
        this.isClientDisabled = true;
        this.isJobDropdownDisabled = false;
        this.isTaskDropdownDisabled = false;
        this.isUnitFieldsEnabled = true;
        this.isStartTimeFieldsEnabled = true;
        this.isCommentFieldsEnabled = true;
        this.isDateFieldsEnabled = false;
        if (this.selectedDataAlt.context === 'MastertimesheetId') {
          this.isRateFieldEnabled = false;
          this.isJobDropdownDisabled = true;
          this.isTaskDropdownDisabled = true;
        } else {
          this.isRateFieldEnabled = true;
        }
        if (this.timesheetFormat) {
          this.isTimeFieldEnabled = false;
        } else {
          this.isTimeFieldEnabled = true;
        }
      } else {
        this.isClientDisabled = false;
        this.isTimeFieldEnabled = false;
      }
      this.isClientDisabled = true;
    } else if (this.sourceComponent == 'headerComponent') {
      this.isClientDisabled = true;
    } else if (this.sourceComponent == 'others') {
      this.isClientDisabled = false;
      this.isUnitFieldsEnabled = this._timeSheetFormat;
      this.isTimeFieldEnabled = !this._timeSheetFormat;
      this.isTaskDropdownDisabled = !!(this.selectedDataAlt.id || this.resData);
      this.isDateFieldsEnabled = true;
      this.isStartTimeFieldsEnabled = true;
      this.isRateFieldEnabled = true;
      this.isCommentFieldsEnabled = true;
    } else {
      this.isClientDisabled = true;
    }
  }

  popuplateMultipleCellSelectedFields() {
    this.startDateTime = this.preparedMultiCellSelectedObj.timelogStartTime;
    this.selectedUnitValue = this.preparedMultiCellSelectedObj.timelogUnitValue;
    this.calculatedTime = this.preparedMultiCellSelectedObj.timelogTimeValue;
  }

  
  getClientListData() {
    this.quickAddClientList = [];
    this.quickAddNonBillableList = [];

    if (this.sourceComponent === 'NewTimesheetComponent') {
      this.fetchClientData();
    } else if (this.timesheetClientList && this.timesheetClientList.length > 0) {
      const processedList = this.timesheetClientList.map(item => {
        if (item.uniqueItemTypeProperty === 'Client') {
          return {
            ...item,
            uniqueItemTypeProperty: 'Client',
            displayClientName: item.displayClientName || `${item.clientName} (${item.clientCode})`,
          };
        } else if (item.uniqueItemTypeProperty === 'Non-billable') {
          return {
            ...item,
            uniqueItemTypeProperty: 'Non-billable',
            displayClientName: item.displayClientName || item.displayTextName || item.name,
          };
        }
        return null;
      }).filter(item => item !== null);

      this.quickAddClientList = processedList.filter(x => x.uniqueItemTypeProperty === 'Client');
      this.quickAddNonBillableList = processedList.filter(x => x.uniqueItemTypeProperty === 'Non-billable');
      this.setDropdownItemListBasedOnContext();
    } else {
      this.fetchClientData();
    }
  }

  fetchClientData() {
    forkJoin({
      clientList: this.clientService.GetClientListForCombo(),
      leaveList: this._timesheetService.GetMasterTimeSheetDetailsByUserId(this.userId)
    }).pipe(takeUntil(this.unsubscribe)).subscribe(({ clientList, leaveList }) => {

      if (clientList) {
        this.quickAddClientList = clientList
          .filter(x => !(x.status === 'Archive' || x.status === 'Lost'))
          .map(client => ({
            ...client,
            uniqueItemTypeProperty: 'Client',
            displayClientName: `${client.clientName} (${client.clientCode})`,
            isNonBillable: false
          }));
      }

      if (leaveList) {
        this.quickAddNonBillableList = leaveList
          .filter(x => x.flag === 3)
          .map(leave => ({
            ...leave,
            uniqueItemTypeProperty: 'Non-billable',
            displayClientName: leave.displayTextName,
            isNonBillable: true
          })).sort((a, b) => a.displayClientName.localeCompare(b.displayClientName));
      }

      this.setDropdownItemListBasedOnContext();
    });
  }


   setDropdownItemListBasedOnContext() {
    if (this.sourceComponent === 'NewTimesheetComponent') {
      this.dropdownItemList = [...this.quickAddClientList, ...this.quickAddNonBillableList];
      this.activeClientTab = this.selectedDataAlt?.context === 'MastertimesheetId' ? 'non-billable' : 'billable';
      this.setClientTab(this.activeClientTab);
    }
    else if (this.sourceComponent === 'headerComponent') {
      this.dropdownItemList = this.quickAddTimesheetClientList;
    }
    else {
      this.dropdownItemList = [...this.quickAddClientList, ...this.quickAddNonBillableList];
    }
  }

  customSort(a: string, b: string): number {
    const isSpecialChar = (str: string) => /^[^a-zA-Z0-9]/.test(str);
    const isNumber = (str: string) => /^[0-9]/.test(str);
    const isUpperCase = (str: string) => /^[A-Z]/.test(str);
    const isLowerCase = (str: string) => /^[a-z]/.test(str);

    if (isSpecialChar(a) && !isSpecialChar(b)) return -1;
    if (!isSpecialChar(a) && isSpecialChar(b)) return 1;

    if (isNumber(a) && !isNumber(b)) return -1;
    if (!isNumber(a) && isNumber(b)) return 1;

    if (isUpperCase(a) && !isUpperCase(b)) return -1;
    if (!isUpperCase(a) && isUpperCase(b)) return 1;

    if (isLowerCase(a) && !isLowerCase(b)) return -1;
    if (!isLowerCase(a) && isLowerCase(b)) return 1;

    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
  }

  getClientListDataAlt() {
    let timesheetClientListArray = [];
    let timesheetLeaveListArray = [];
    let combineClientAndLeave = [];

    forkJoin({
      clientList: this.clientService.GetClientListForCombo(),
      leaveList: this._timesheetService.GetMasterTimeSheetDetailsByUserId(this.userId)
    }).pipe(takeUntil(this.unsubscribe)).subscribe(({ clientList, leaveList }) => {
      if (clientList) {
        timesheetClientListArray = clientList.filter(x => !(x.status === 'Archive' || x.status === 'Lost')).map(client => ({
          ...client,
          uniqueItemTypeProperty: 'Client',
          displayClientName: `${client.clientName} (${client.clientCode})`,
          isNonBillable: false
        }));
      }

      if (leaveList) {
        timesheetLeaveListArray = leaveList.filter(x => x.flag === 3).map(leave => ({
          ...leave,
          uniqueItemTypeProperty: 'Non-billable',
          displayClientName: leave.displayTextName,
          isNonBillable: true
        }));
      }
      combineClientAndLeave = [...timesheetClientListArray, ...timesheetLeaveListArray];
      combineClientAndLeave.sort((a, b) => this.customSort(a.displayClientName, b.displayClientName));
      this.quickAddTimesheetClientList = combineClientAndLeave;
      this.setDropdownItemListBasedOnContext();
    });
  }
  activeClientTab: string = 'billable';
setClientTab(type: string) {

  this.activeClientTab = type;
   this.isAltShortcutActive = false;

  if (this.sourceComponent === 'NewTimesheetComponent') {
    if (type === 'billable') {
      this.dropdownItemList = this.quickAddClientList;
    } else {
      this.dropdownItemList = this.quickAddNonBillableList;
    }
  } else {
    if (type === 'billable') {
      this.dropdownItemList = this.quickAddTimesheetClientList
        .filter(x => !x.isNonBillable);
    } else {
      this.dropdownItemList = this.quickAddTimesheetClientList
        .filter(x => x.isNonBillable);
    }
  }

  // Only reset selection if the currently selected client is not in the new list
  if (this.quickAddSelectedTimesheetClient) {
    let isSelectedInList = false;
    if (typeof this.quickAddSelectedTimesheetClient === 'string') {
      isSelectedInList = this.dropdownItemList.some(client => client.displayClientName === this.quickAddSelectedTimesheetClient);
    } else {
      isSelectedInList = this.dropdownItemList.some(client => client.clientId === this.quickAddSelectedTimesheetClient.clientId);
    }
    if (!isSelectedInList) {
      this.quickAddSelectedTimesheetClient = null;
    }
  }

  this.resetClientDropdownScrollToTop();
}

  private resetClientDropdownScrollToTop() {
    timer(0).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      if (this.clientDropdown?.isOpen) {
        const clientDropdownAny = this.clientDropdown as any;
        clientDropdownAny.close?.();

        timer(0).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
          clientDropdownAny.open?.();
          clientDropdownAny.itemsList?.markSelectedOrDefault?.(true);
          clientDropdownAny.detectChanges?.();
          clientDropdownAny.dropdownPanel?.scrollTo?.(clientDropdownAny.itemsList?.markedItem, true);
        });
      }
    });
  }
   onClientDropdownKeydown(event: KeyboardEvent) {
    if (event.key === 'Alt') {
      if (event.repeat) {
        return;
      }
      event.preventDefault();
      this.isAltShortcutActive = !this.isAltShortcutActive;
      return;
    }

    if (!event.altKey) return;
    if (event.key === 'b' || event.key === 'B') {
      event.preventDefault();
      this.setClientTab('billable');
    } else if (event.key === 'n' || event.key === 'N') {
      event.preventDefault();
      this.setClientTab('non-billable');
    }
  }

  onClientDropdownKeyup(event: KeyboardEvent) {
    if (!event) return;
  }

  onClientDropdownMousedown(event: MouseEvent) {
    if (event.altKey) {
      this.isAltShortcutActive = true;
    }
  }

  @HostListener('document:mousedown', ['$event'])
  onDocumentMouseDown(event: MouseEvent): void {
    if (!this.isAltShortcutActive) return;
    const target = event.target as HTMLElement;
    if (!target) return;
    if (target.closest('.clientaddnew-drdwn')) return;
    this.isAltShortcutActive = false;
  }

  closeQuickAddpopup(result?: any) {
    this.closeQuickAddTimesheetEntryPopup.emit(result);
  }

  timesheetClientColDropdown(event: any) {
    this.selectedTimesheetClientID = event.clientId;
    this.disableRate = false; 

    if (this.selectedTimesheetClientID === 0){
      /* clear job and task's selection as soon as non-billable item is selected */
      this.selectedTimesheetJob = null;
      this.isJobDropdownDisabled = true;
      this.selectedTimesheetTask = null;
      this.isTaskDropdownDisabled = true;
    }

    const selectedDate = new Date(this.timesheetdatePickerdefault);
    //hiding this feature to log the time for Non-Billable on leave days - CUST-10541
    // const isValidAsPerHoliday = this.validateHolidayValidation(selectedDate);
    // if(!isValidAsPerHoliday){
    //   return;
    // }

    if (this.sourceComponent === 'NewTimesheetComponent') {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      const isFutureDate = selectedDate > currentDate;

      if (isFutureDate && this.selectedTimesheetClientID !== 0) {
        this.isDateFieldsEnabled = false;
        this.isStartTimeFieldsEnabled = false;
        this.isUnitFieldsEnabled = false;
        this.isTimeFieldEnabled = false;
        this.isRateFieldEnabled = false;
        this.isCommentFieldsEnabled = false;
        this._toastr.error("You can't log for a future date", 'Timesheet');
        return;
      }
    }
    if (this.selectedTimesheetClientID === 0 && (event.category == 'Leave' || event.category == 'Non-productive' || event.category == 'Productive')) {
      if (this._timeSheetFormat) {
        timer(200).pipe(takeUntil(this.unsubscribe)).subscribe(() => { this.unitquicktime.toArray()[0].nativeElement.focus(); });
      }
      else {
        timer(200).pipe(takeUntil(this.unsubscribe)).subscribe(() => { this.quicktime.toArray()[0].nativeElement.focus(); });
      }
    } else {
      this.getJobsforSelectedClients();
    }
    this.isJobDropdownDisabled = false;
    this.isTaskDropdownDisabled = true;
    if (this.selectedTimesheetClientID == 0) {
      if (this.sourceComponent == 'others' || this.sourceComponent == 'headerComponent') {
        this.startDateTime = this.setDefaultStartTime();
      }
      this.selectedContextIdForleave = event.contextId;
      this.isJobDropdownDisabled = true;
      this.isTaskDropdownDisabled = true;
      this.isUnitFieldsEnabled = true;
      this.isStartTimeFieldsEnabled = true;
      this.isCommentFieldsEnabled = true;
      this.isDateFieldsEnabled = this.sourceComponent === 'headerComponent';
      this.isTimeFieldEnabled = !this._timeSheetFormat;
      this.isRateFieldEnabled = false;
      this.disableRate = false;
      this.selectedDefaultRate = null;
    } else {
      this.isRateFieldEnabled = true;
      const selectedTask = this.timesheetTaskList.find(task => task.taskId === this.selectedTimesheetTask);
      if (selectedTask) {
        this.applyRateRuleForTaskCategory(Number(selectedTask.taskCategory), this.userDefaultRate?.billRate);
      }
    }
    if (this.selectedDataAlt) {
      if (this.selectedTimesheetClientID != this.selectedDataAlt.clientId) {
        this.selectedTimesheetJob = null;
        this.selectedTimesheetTask = null;
      }
    } else {
      this.selectedTimesheetJob = null;
      this.selectedTimesheetTask = null;
    }

  }

  timesheetJobColDropdown() {
    this.selectedTimesheetJobID = this.selectedTimesheetJob;
    this.isUnitFieldsEnabled = true;
    this.isStartTimeFieldsEnabled = true;
    this.isCommentFieldsEnabled = true;
    this.isDateFieldsEnabled = true
    if (this.sourceComponent == 'others' || this.sourceComponent == 'headerComponent') {
      this.startDateTime = this.setDefaultStartTime();
    }
    if (this._timeSheetlevel) {
      if (this._timeSheetFormat) {
        timer(200).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
          this.unitquicktime.toArray()[0].nativeElement.focus();
        });
      }
      else {
        timer(200).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
          this.quicktime.toArray()[0].nativeElement.focus()
        });
      }
    } else {
      this.selectedTimesheetTask = null;
      this.GetTimesheetTasklistByContextType(this.selectedTimesheetJobID);
    }
    this.isTaskDropdownDisabled = false;
    this.isTimeFieldEnabled = !this._timeSheetFormat;

  }
  setDefaultStartTime(): Date {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 8, 0, 0);
  }

  timesheetTaskColDropdown() {
    this.selectedTimesheetTaskID = this.selectedTimesheetTask;
    if (this.selectedTimesheetTaskID) {
      this.isUnitFieldsEnabled = true;
      this.isStartTimeFieldsEnabled = true;
      this.isCommentFieldsEnabled = true;
      this.isDateFieldsEnabled = true;
      if (this._timeSheetFormat) {
        timer(200).pipe(takeUntil(this.unsubscribe)).subscribe(() => { this.unitquicktime.toArray()[0].nativeElement.focus(); });
      }
      else {
        this.isTimeFieldEnabled = true;
        timer(200).pipe(takeUntil(this.unsubscribe)).subscribe(() => { this.quicktime.toArray()[0].nativeElement.focus(); });
      }

      const selectedTask = this.timesheetTaskList.find(task => task.taskId === this.selectedTimesheetTaskID);
      this.applyRateRuleForTaskCategory(Number(selectedTask?.taskCategory), this.userDefaultRate?.billRate);
    }
  }

  timesheetClientColDropdownClear() {
    this.isTimeFieldEnabled = false;
    this.selectedTimesheetJob = null;
    this.selectedTimesheetTask = null;
    this.quickAddSelectedTimesheetClient = null;
    this.isJobDropdownDisabled = true;
    this.isTaskDropdownDisabled = true;
    this.selectedUnitValue = null;
    this.calculatedTime = null;
    this.selectedDefaultRate = null;
    this.disableRate = false;
    this.isRateFieldEnabled = false;
    this.isUnitFieldsEnabled = false;
    this.isStartTimeFieldsEnabled = false;
    this.isDateFieldsEnabled = false;
    this.isCommentFieldsEnabled = false;
  }

  timesheetJobColDropdownClear() {
    this.selectedTimesheetTask = null;
    this.isTaskDropdownDisabled = true;
    this.isTimeFieldEnabled = false;
    this.selectedUnitValue = null;
    this.calculatedTime = null;
    this.selectedDefaultRate = null;
    this.disableRate = false;
    this.isRateFieldEnabled = false;
    this.isUnitFieldsEnabled = false;
    this.isStartTimeFieldsEnabled = false;
    this.isDateFieldsEnabled = false;
    this.isCommentFieldsEnabled = false;
    this.openJonDropDown();
  }

  openJonDropDown() {
    timer(100).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.jobDropdown.open();
    });
  }

  timesheetTaskColDropdownClear() {
    this.isJobDropdownDisabled = false;
    this.selectedUnitValue = null;
    this.isTimeFieldEnabled = false;
    this.calculatedTime = null;
    this.selectedDefaultRate = null;
    this.disableRate = false;
    this.isRateFieldEnabled = false;
    this.isUnitFieldsEnabled = false;
    this.isStartTimeFieldsEnabled = false;
    this.isDateFieldsEnabled = false;
    this.isCommentFieldsEnabled = false;
    this.openJonDropDown();
  }

  getJobsforSelectedClients() {
    if (this.selectedTimesheetClientID !== null) {
      let jobCategory = 2;
      this._timesheetService.getClientJobsList(this.selectedTimesheetClientID, jobCategory).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result) {

          this.timesheetJobList = result?.filter(job => !job.finalExist).map(job => ({
            ...job,
            displayJobName: `${job.jobName}`,
            isWIPPeriodClosed: this.getIsWIPClosed(job.startDuration, job.endDuration),
            disabled: this.getIsWIPClosed(job.startDuration, job.endDuration) || job.finalExist
          }));
        }
        this.timesheetJobList.sort((a, b) => this.customSort(a.displayJobName.toString(), b.displayJobName.toString()));
        if (this.timesheetJobList.length == 1) {
          this.selectedTimesheetJob = this.timesheetJobList[0].jobId;

          this.jobDropdown.close();
          this.timesheetJobColDropdown();
        } else {
          this.openJonDropDown();
          this.selectedTimesheetJob = undefined;
          this.selectedTimesheetTask = undefined;
        }

      });
    }
  }

  getIsWIPClosed(wipInitialStartDate, WIPEndDate): boolean {
    if (wipInitialStartDate != '0001-01-01T00:00:00') {
      let timesheetWipEndDate = new Date(WIPEndDate);
      let intialWipStartDate = new Date(wipInitialStartDate);
      let convertedSelectedDate = new Date(this.datepipe.transform(this.timesheetdatePickerdefault, 'MM/dd/yyyy'));

      if (convertedSelectedDate >= intialWipStartDate && convertedSelectedDate <= timesheetWipEndDate) {
        return true;
      }
      else {
        return false;
      }
    } else {
      return false;
    }
  }

  GetTimesheetTasklistByContextType(ContextId: number) {
    if (ContextId != undefined) {
      this._timesheetService.getTimesheetTaskByID(ContextId).pipe(takeUntil(this.unsubscribe)).subscribe((res: any[]) => {
        if (res) {
          this.timesheetTaskList = res.filter(task => (task.taskCategory & 2 || task.taskCategory & 4));
          if (this.timesheetTaskList.length === 1) {
            this.selectedTimesheetTask = this.timesheetTaskList[0].taskId;
            this.timesheetTaskColDropdown();
            this.taskDropdown.close();
          } else {
            timer(100).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
              this.taskDropdown.open();
            });
          }
        } else {
          this._toastr.error("Failed, please try again!");
        }
      });
    }
  }

  GetPracticeTimesheetdeatil() {
    this.firmDetailService.GetFirmTimeSheetSettingById().pipe(takeUntil(this.unsubscribe)).subscribe((result: any) => {
      if (result) {
        this._timeSheetFormat = result?.timeSheetFormat;
        this._timeSheetlevel = result?.timeSheetlevel;
        this._timeSheetUnitVal = result?.unitvalue;
        this._timesheetpracticwesetting = result;
        this.enablingFields();
      }
    });
  }

  disableRate: boolean = false;

  private isTaskCategoryRateDisabled(taskCategory: number | null | undefined): boolean {
    return taskCategory === 4 || taskCategory === 5;
  }

  private applyRateRuleForTaskCategory(taskCategory: number | null | undefined, fallbackRate: any): void {
    const shouldDisableRate = this.isTaskCategoryRateDisabled(taskCategory);
    this.disableRate = shouldDisableRate;
    this.selectedDefaultRate = shouldDisableRate ? 0 : fallbackRate;
  }

  Getuser() {
    this.userId = (this.timesheetName === 'My Timesheet' || this.sourceComponent === 'others' || this.sourceComponent === 'headerComponent')
      ? this.userId
      : this.UserId;

    this.userManagementService.getUserManagementDetailsById(this.userId)
      .subscribe(result => {
        this.allRates = result.multiBillRates;
        this.applyRateFilter();

        if (this.sourceComponent === 'others' || this.sourceComponent === 'headerComponent') {
          timer(500).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            this.applyRateRuleForTaskCategory(this.selectedDataAlt?.taskCategory, this.userDefaultRate?.billRate);

            this.timesheetdatePickerdefault = new Date();
            this.startDateTime = this.setDefaultStartTime();
            this.getListOfMonthHolidays(this.timesheetdatePickerdefault);
          });
        } else {
          this.selectedDefaultRate = this.selectedDataAlt?.finalRate ?? this.userDefaultRate?.billRate;
        }
      }, error => console.error(error));
  }

  lastSelectedMonthYear = '';

  onDateSelection(event: any) {
    const selectedDateObj = this.normalizeToDate(event) || this.timesheetdatePickerdefault;
    const selectedDate = this.datepipe.transform(selectedDateObj, 'dd/MM/yyyy') || '';
    const existingTime = this.datepipe.transform(this.startDateTime, 'HH:mm:ss') || '00:00:00';
    if (selectedDateObj.getTime() > Date.now()) {
      this._toastr.error("Timesheet entries must be dated on or before the current date.");
      this.timesheetdatePickerdefault = null;
      return;
    }
    this.GetDailyTimeSheetData();
    this.startDate = `${selectedDate} ${existingTime}`;
    
    this.getListOfMonthHolidays(selectedDateObj);
    this.updateHolidayFlag(selectedDateObj);
    this.applyRateFilter();
  }

  getListOfMonthHolidays(date: Date) {
    const _year = date.getFullYear();
    const _month = date.getMonth();
    const selectedMonthYear = `${_month}-${_year}`;

    if (this.lastSelectedMonthYear === selectedMonthYear) {
      this.updateHolidayFlag(date);
      return;
    }

    this._timesheetService.GetWeeklyTimesheetHolidayDetail(this.datepipe.transform(new Date(_year, _month, 1), 'yyyy-MM-d'), this.datepipe.transform(new Date(_year, _month, 31), 'yyyy-MM-d'), true).subscribe((response)=>{
      this.selectedMonthHolidays = response;
      this.lastSelectedMonthYear = selectedMonthYear;
      this.updateHolidayFlag(date);
    });
  }

  private normalizeToDate(value: any): Date | null {
    if (!value) {
      return null;
    }
    if (value instanceof Date) {
      return value;
    }
    if (value && typeof value.toDate === 'function') {
      return value.toDate();
    }
    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  private updateHolidayFlag(date: Date): void {
    const selectedDate = this.normalizeToDate(date);
    if (!selectedDate || !this.selectedMonthHolidays?.length) {
      this.isHoliday = false;
      return;
    }

    selectedDate.setHours(0, 0, 0, 0);
    this.isHoliday = this.selectedMonthHolidays.some(holiday => {
      if (!holiday?.isHoliday || !holiday?.holidayDate) {
        return false;
      }
      const holidayDate = new Date(holiday.holidayDate);
      holidayDate.setHours(0, 0, 0, 0);
      return holidayDate.getTime() === selectedDate.getTime();
    });
  }

  // validateHolidayValidation(selectedDate: Date): boolean {
  //   this.isHoliday = this.selectedMonthHolidays?.some(
  //     holiday => {
  //       const holidayDate = new Date(holiday.holidayDate);
  //       return holidayDate.toDateString() === selectedDate.toDateString() && holiday.isHoliday;
  //     }
  //   );

  //   if (this.isHoliday && this.selectedTimesheetClientID === 0) {
  //     this.disableAddButton = true;
  //     this._toastr.error("Leave cannot be applied on holidays.", 'Timesheet');
  //     return false;
  //   } else {
  //     if (!this.isUserAllowedToLog) {
  //       this.disableAddButton = true;
  //     }
  //     else {
  //       this.disableAddButton = false;
  //     }   
  //     return true;
  //   }
  // }
  calculateTime(): void {
    const unitValue = this.selectedDataAlt?.clientId && this.sourceComponent == 'NewTimesheetComponent' ? this.selectedDataAlt.unitValue : this._timeSheetUnitVal;
    if (!this.selectedUnitValue || this.selectedUnitValue <= 0) {
      this.calculatedTime = '';
      return;
    }
    const maxUnits = Math.floor((this.maxHoursPerDay * 60) / unitValue);
    if (this.selectedUnitValue > maxUnits) {
      this._toastr.error(`A maximum of ${maxUnits} units can be logged per entry`, 'Timesheet');
      this.selectedUnitValue = null;
    } else if (this.selectedUnitValue > 0) {
      const totalMinutes = Math.round(this.selectedUnitValue * unitValue);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      this.calculatedTime = this.formatTime(hours, minutes);
    }
  }

  outsideUnit() {
    clearTimeout(this.unitqtTimeout);
  }

  private unitqtTimeout: any;
  outsideClick(event) {
    timer(200).pipe(takeUntil(this.unsubscribe)).subscribe(() => { this.descpquicktime.toArray()[0].nativeElement.focus(); });
  }

  formatTime(hours: number, minutes: number): string {
    const formattedMinutes = String(minutes).padStart(2, '0');
    return `${hours}:${formattedMinutes}`;
  }

  convertTimeToUnits(timeStr: string): number {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const totalMinutes = (hours * 60) + minutes;
    const units = totalMinutes / this._timeSheetUnitVal;
    return Math.round(units);
  }

  enableFields: boolean = false;
  handleTimeInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    this.calculatedTime = input;
  }

  convertMinutesToTime(): void {
    timer(200).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      if (!this._timeSheetFormat && this.selectedTimesheetClientID === 0) {
        this.descpquicktime.toArray()[0].nativeElement.focus()
      }
    });
    const timeFormatWithColon = /^(\d{1,2}):(\d{2})$/;
    const decimalFormat = /^(\d*(\.\d{1,2})?)$/;
    const invalidColonPattern = /:{2,}/;
    let totalMinutes: number;

    if (invalidColonPattern.test(this.calculatedTime)) {
      this._toastr.error("Invalid time format. Please enter as hh:mm or decimal hours.", "Invalid Format");
      this.calculatedTime = '';
      return;
    }
    if (!this.calculatedTime || isNaN(Number(this.calculatedTime.replace(/:/g, '')))) {
      this.calculatedTime = '';
      return;
    }

    if (timeFormatWithColon.test(this.calculatedTime)) {
      const [hours, minutes] = this.calculatedTime.split(':').map(Number);
      totalMinutes = hours * 60 + minutes;
    }
    else if (decimalFormat.test(this.calculatedTime)) {
      const hoursAsDecimal = parseFloat(this.calculatedTime);
      totalMinutes = Math.round(hoursAsDecimal * 60);
    }
    else {
      this._toastr.error("Invalid time format. Please enter as hh:mm or decimal hours.", "Invalid Format");
      return;
    }

    const finalHours = Math.floor(totalMinutes / 60);
    const finalMinutes = totalMinutes % 60;

    if (totalMinutes > 480) {
      this._toastr.error("You can't log more than 8 hours per entry", "Timesheet");
      this.calculatedTime = '';
    } else {
      this.calculatedTime = this.formatTimeminutes(finalHours, finalMinutes);
    }
  }

  formatTimeminutes(hours: number, minutes: number): string {
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    return `${hours}:${formattedMinutes}`;
  }

  numberOnly(event: KeyboardEvent): boolean {
    const key = event.key;
    if ((key >= '0' && key <= '9') || key === '.') {
      if (key === '.' && (event.target as HTMLInputElement).value.includes('.')) {
        return false;
      }
      return true;
    }
    return false;
  }

  getJobsAndTaskForSelectedClient() {
    if (this.selectedClientId !== null) {
      forkJoin([
        this._timesheetService.getClientJobsList(this.selectedClientId),
        this._timesheetService.getTimesheetTaskByID(this.selectedContextId)
      ]).pipe(takeUntil(this.unsubscribe)).subscribe(
        ([jobsResult, tasksResult]) => {
          if (jobsResult) {

            this.timesheetJobList = jobsResult.map(job => ({
              ...job,
              displayJobName: `${job.jobCode} - ${job.jobName}`,
              disabled: job.finalExist ? true : false
            }));

          }
          if (tasksResult) {
            this.timesheetTaskList = (tasksResult as any).filter(task => (task.taskCategory & 2 || task.taskCategory & 4));
          } else {
            this._toastr.error("Failed to load tasks, please try again!");
          }
          this.populateFormFields();
        },
        (error) => {
          this._toastr.error("Failed to load jobs and tasks, please try again!");
        }
      );

    }
  }

  startTimeLog(event: any) {
    const startTime = event.text;
    const startingDate = this.datepipe.transform(this.timesheetdatePickerdefault, 'dd/MM/yyyy');
    if (startingDate && startTime) {
      const [time, modifier] = startTime.split(' ');
      let [hours, minutes] = time.split(':').map(Number);

      if (modifier === 'PM' && hours < 12) {
        hours += 12;
      } else if (modifier === 'AM' && hours === 12) {
        hours = 0;
      }
      const formattedTime = `${this.padZerocal(hours)}:${this.padZerocal(minutes)}:00`;
      const formattedDateTime = `${startingDate} ${formattedTime}`;
      this.startDate = formattedDateTime;
    }
  }

  padZerocal(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

  onFocusStartTime(event: any,) {
    const startTime = event.model.prevValue;
    const startingDate = this.datepipe.transform(this.timesheetdatePickerdefault, 'dd/MM/yyyy');
    if (startingDate && startTime) {
      const [time, modifier] = startTime.split(' ');
      let [hours, minutes] = time.split(':').map(Number);
      if (modifier === 'PM' && hours < 12) {
        hours += 12;
      } else if (modifier === 'AM' && hours === 12) {
        hours = 0;
      }
      const formattedTime = `${this.padZerocalAlt(hours)}:${this.padZerocalAlt(minutes)}:00`;
      let newStartDateTime = `${startingDate}T${formattedTime}`;
      newStartDateTime = newStartDateTime.replace('T', ' ');
      const responseStartDateTime = this.loggedData[0].startDateTime;
      if (this.compareDateTime(newStartDateTime, responseStartDateTime)) {
        this.loggedData[0].startDateTime = newStartDateTime;
      } else {
        this.loggedData[0].startDateTime = responseStartDateTime;
      }
    }
  }

  compareDateTime(newDateTime: string, responseDateTime: string): boolean {
    const newDate = new Date(newDateTime).getTime();
    const responseDate = new Date(responseDateTime).getTime();
    return newDate !== responseDate;
  }

  padZerocalAlt(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  validationForLogEntry(): boolean {
    if (!this.startDateTime) {
      this._toastr.error("Please enter a valid start time.", "Timesheet");
      return false;
    }
    if (this._timeSheetFormat) {
      const totalUnitMinutes = this.selectedUnitValue * this._timeSheetUnitVal;
      const startDateTime = new Date(this.startDateTime);
      const startHour = startDateTime.getHours();
      const startMinute = startDateTime.getMinutes();
      const totalStartMinutes = startHour * 60 + startMinute;
      const minutesInADay = 1440;
      const remainingMinutesForDay = minutesInADay - totalStartMinutes;
      if (totalUnitMinutes > remainingMinutesForDay) {
        const remainingHours = remainingMinutesForDay / 60;
        const displayHours = Number.isInteger(remainingHours)
          ? remainingHours.toString()
          : remainingHours.toFixed(1);
        const hourSuffix = remainingHours === 1 ? 'hour' : 'hours';
        this._toastr.error(`For the chosen start time, you can log up to ${displayHours} ${hourSuffix}.`, 'Timesheet');
        return false;
      }
    } else {
      if (!this.calculatedTime || this.calculatedTime === '0' || this.calculatedTime === '0:00') {
        this._toastr.error("You must enter a valid time greater than zero.", "Timesheet");
        return false;
      }
      const [hours, minutes] = this.calculatedTime.split(':').map(Number);
      const enteredMinutes = hours * 60 + minutes;
      const startDateTime = new Date(this.startDateTime);
      const startHour = startDateTime.getHours();
      const startMinute = startDateTime.getMinutes();
      const totalStartMinutes = startHour * 60 + startMinute;
      const minutesInADay = 1440;
      const remainingMinutesForDay = minutesInADay - totalStartMinutes;
      if (enteredMinutes > remainingMinutesForDay) {
        const remainingHours = remainingMinutesForDay / 60;
        const displayHours = Number.isInteger(remainingHours) ? remainingHours.toString() : remainingHours.toFixed(1);
        const hourSuffix = remainingHours === 1 ? 'hour' : 'hours';
        this._toastr.error(`For the chosen start time, you can log up to ${displayHours} ${hourSuffix}.`, 'Timesheet');
        return false;
      }
    }
    return true;
  }

  checkForChanges(): boolean {
    const selectedStartDateTime = new Date(this.selectedDataAlt?.startDateTime).toISOString();
    const currentStartDateTime = new Date(this.startDateTime).toISOString();

    const normalizeDuration = (duration: string) => {
      const [hours, minutes] = duration.split(":").map(Number);
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    };
    const normalizedSelectedDuration = normalizeDuration(this.selectedDataAlt?.durationStr);
    const normalizedCurrentDuration = normalizeDuration(this.calculatedTime);
    const isUnitChanged = this.selectedDataAlt.unit !== this.selectedUnitValue;
    const isRateChanged = this.selectedDataAlt.finalRate !== this.selectedDefaultRate;
    const isDurationChanged = normalizedSelectedDuration !== normalizedCurrentDuration;
    const isStartTimeChanged = selectedStartDateTime !== currentStartDateTime;

    const isClientChanged = this.selectedDataAlt.clientName !== this.quickAddSelectedTimesheetClient;
    const isJobChanged = this.selectedDataAlt.jobId !== this.selectedTimesheetJob;
    const isTaskChanged = this.selectedDataAlt.taskId !== this.selectedTimesheetTask;

    return (
      isUnitChanged ||
      isRateChanged ||
      isDurationChanged ||
      isStartTimeChanged ||
      isClientChanged ||
      isJobChanged ||
      isTaskChanged
    );
  }

  addDailyLogData() {
    if (this.selectedDataAlt?.logTimeId > 0) {
      const hasFieldChanges = this.checkForChanges();
      if (hasFieldChanges && this.selectedComment) {
        this.addDailyLogtime();
      } else if ((this.selectedComment || this.selectedDataAlt.commentId != 0) && !hasFieldChanges) {
        this.getTimeSheetCommentByLogId(this.selectedDataAlt.logTimeId);
      } else if (hasFieldChanges) {
        this.addDailyLogtime();
      }
    } else {
      this.addDailyLogtime();
    }
  }

  addDailyLogtime() {
    if (!this.validationForLogEntry()) {
      return;
    }
    let dynamicContextId;
    let mastertimesheetId;
    const selectedClient = this.dropdownItemList.find(
      client => client.contextId === this.selectedContextIdForleave
    );

    if ((selectedClient?.category === 'Leave' || selectedClient?.category === 'Non-productive' || selectedClient?.category === 'Productive') && selectedClient?.contextId) {
      dynamicContextId = selectedClient.contextId;
      mastertimesheetId = selectedClient.contextId;
    } else {
      dynamicContextId = !this._timeSheetlevel ? this.selectedTimesheetTask : this.selectedTimesheetJob;
      mastertimesheetId = (this.selectedTimesheetClientID === 0 && this.selectedContextIdForleave)
        ? this.selectedContextIdForleave
        : 0;
    }
    this.dailyLogTimeContextId = dynamicContextId;
    const [hours, minutes] = this.calculatedTime.split(':').map(Number);
    const loggedTimeDecimal = parseFloat(`${hours}.${minutes < 10 ? '0' : ''}${minutes}`);
    let context = '';
    if (this.selectedTimesheetTask && !this._timeSheetlevel) {
      context = 'TaskId';
    } else if (this.selectedTimesheetJob) {
      context = 'JobId';
    } else if (this.selectedTimesheetClientID == 0) {
      context = 'MastertimesheetId';
    }
    let logTimeId = 0;
    if (this.selectedDataAlt) {
      logTimeId = this.selectedDataAlt?.logTimeId || 0;
    }
    const formattedStartDateTime = this.formatDateTime(this.startDateTime);
    let requestBody = {
      userId: this.timesheetName == 'My Timesheet' ? this.userId : this.UserId,
      logTimeId: logTimeId ? logTimeId : 0,
      contextId: dynamicContextId,
      context: context,
      isBillable: this.selectedTimesheetClientID !== 0,
      unitValue: this.selectedDataAlt?.clientId && this.sourceComponent == 'NewTimesheetComponent' ? this.selectedDataAlt?.unitValue : this._timeSheetUnitVal,
      finalRate: this.selectedDefaultRate ? this.selectedDefaultRate : 0,
      clientId: this.selectedTimesheetClientID ? this.selectedTimesheetClientID : 0,
      jobId: this.selectedTimesheetJob ? this.selectedTimesheetJob : 0,
      taskId: mastertimesheetId ? 0 : (this._timeSheetlevel ? 0 : this.selectedTimesheetTask),
      mastertimesheetId: mastertimesheetId || 0,
      unit: +this.selectedUnitValue,
      durationStr: this.calculatedTime.toString().replace(":", "."),
      strtdate: this.startDate ? this.startDate : formattedStartDateTime,
      statusId: this._timesheetpracticwesetting?.timeSheetApproval ? 2 : 4,
      cost: 0,
      loggedTime: loggedTimeDecimal,
    }
    this.logtimeService.PostDailyLogTime(requestBody).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (response: any) => {
      if(response?.response?.success || response?.success) {
      this.eventService.broadcastEvent(CommonEvents.TIMELOG_UPDATE, true);
      const result = {
        customField: response?.customFields?.[0],
        disbursement: response?.result?.[0]
      }
      if (response == "Limited access") {
        this.closeQuickAddpopup(result);
      }
      else if (response?.response?.success) {
        if (this.selectedComment || this.selectedDataAlt?.commentId) {
          /* getTimeSheetCommentByLogId already has closeQuickAddpopup */
          this.getTimeSheetCommentByLogId(response, this.dailyLogTimeContextId);
        }else {
          this.closeQuickAddpopup(result);
        }
        this._toastr.success('successfully captured log time', 'Timesheet');
      } else if (response?.response?.operationStatuses[0]?.uniqueKey == -6) {
          /* -6 is the error code if the timesheet is already billed, so give warning and close the popup */
          this._toastr.error(response?.response?.message);
          this.closeQuickAddpopup(result);
      } else {
          this._toastr.warning(response?.response?.message);
      }
      } else {
        this._toastr.error(response?.response?.message ?? response?.message);
      }
    },
      error: (error: any) => {
        this._toastr.error('An error occurred while posting log time.');
        this.closeQuickAddpopup();
      }
    });
  }

  getTimeSheetCommentByLogId(response?: any, dailyLogTimeContextId?: number): void {
    const CommentLogtimeId = response && response?.response?.operationStatuses && response?.response?.operationStatuses.length > 0
      ? response?.response?.operationStatuses[0].uniqueKey
      : (this.selectedDataAlt ? this.selectedDataAlt.logTimeId : 0);
    let CommentItemName;
    const selectedClientAlt = this.quickAddTimesheetClientList.find(
      client => client.clientId === this.quickAddSelectedTimesheetClient
    );
    if (selectedClientAlt) {
      CommentItemName = selectedClientAlt.uniqueItemTypeProperty === 'Non-billable'
        ? selectedClientAlt.displayTextName
        : `${selectedClientAlt.displayClientName} - ${this.selectedTimesheetJob}`;
    }
    let dynamicContextId;
    const selectedClient = this.quickAddTimesheetClientList.find(
      client => client.clientId === this.quickAddSelectedTimesheetClient
    );

    if (selectedClient) {
      if ((selectedClient.category === 'Leave' || selectedClient?.category === 'Non-productive'|| selectedClient?.category === 'Productive') && selectedClient.contextId) {
        dynamicContextId = selectedClient.contextId;
      } else {
        dynamicContextId = !this._timeSheetlevel ? this.selectedTimesheetTask : this.selectedTimesheetJob;
      }
    }
    let context = '';
    if (this.selectedTimesheetTask) {
      context = 'TaskId';
    } else if (this.selectedTimesheetJob) {
      context = 'JobId';
    } else if (this.selectedTimesheetClientID == 0) {
      context = 'MastertimesheetId';
    }

    const formattedStartDateTime = this.formatDateTime(this.startDateTime);
    let requestBody = {
      isCompleted: false,
      comment: this.selectedComment.trim(),
      context: context,
      jobId: this.selectedTimesheetJob ? this.selectedTimesheetJob : 0,
      contextId: dynamicContextId ?? dailyLogTimeContextId,
      strtdate: this.startDate ? this.startDate : formattedStartDateTime,
      commentDate: this.timesheetdatePickerdefault,
      itemName: CommentItemName,
      weekStart_At: this.timesheetdatePickerdefault,
      weekEnd_At: this.timesheetdatePickerdefault,
      commentId: this.selectedDataAlt?.commentId && this.selectedDataAlt.commentId !== 0 ? this.selectedDataAlt.commentId : 0,
      TaggedUsers: "",
      logTimeId: CommentLogtimeId
    };
    this.logtimeService.PostTimeLogCommentDaily(requestBody)
      .pipe(takeUntil(this.unsubscribe)).subscribe({
        next: response => {
        this.eventService.broadcastEvent(CommonEvents.TIMELOG_UPDATE, true);
        if (response?.response?.success) {
          this._toastr.success('Description added successfully', 'Timesheet');
          const result = {
            customField: response?.customFields?.[0],
            disbursement: response?.result?.[0]
          }
          this.closeQuickAddpopup(result);
        } else {
          this._toastr.error(response?.response?.message || 'Something went wrong, please try again', 'Timesheet');
        }
      }, error: error => {
        this._toastr.error('Failed to save comment, please try again', 'Timesheet');
      }
  });
  }

  formatDateTime = (dateStr: string) => {
    const dateObj = new Date(dateStr);
    const year = dateObj.getFullYear();
    const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
    const day = ('0' + dateObj.getDate()).slice(-2);
    const hours = ('0' + dateObj.getHours()).slice(-2);
    const minutes = ('0' + dateObj.getMinutes()).slice(-2);
    const seconds = ('0' + dateObj.getSeconds()).slice(-2);

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  dateFilter = (date: Date | null): boolean => {
    if (!date) {
      return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (this.selectedTimesheetClientID == 0) {
      return true;
    }
    return date <= today;
  };

  deleteLoggedData() {
    if (this.selectedDataAlt?.logTimeId > 0) {
      let mainContent: string = '';
      if (this.selectedDataAlt?.context == 'MastertimesheetId') {
        mainContent = `Timesheet entry for <b>Leave - ${this.selectedDataAlt?.name}</b> will be permanently deleted.`;
      } else {
        mainContent = `Timesheet entry for <b>${this.selectedDataAlt?.clientName} - ${this.selectedDataAlt?.jobCode} - ${this.selectedDataAlt?.jobName}</b> will be permanently deleted.`;
      }
      this.bsModalRef = this.modalService.show(KcWarningPopupComponent, {
        class: 'modal-dialog-centered',
        backdrop: 'static',
        keyboard: false,
        initialState: {
          mainContent: mainContent,
          subContent: 'Are you sure to continue?'
        }
      });
      this.bsModalRef.content.event.subscribe(res => {
        if (res === this.warningPopupRes.YES) {
          this._timesheetService.deleteRowData(this.selectedDataAlt?.logTimeId).pipe(takeUntil(this.unsubscribe)).subscribe(response => {
            this.eventService.broadcastEvent(CommonEvents.TIMELOG_UPDATE, true);
            if (response.success) {
              this._toastr.success('Time log deleted successfully', 'TimeSheet');
              this.closeQuickAddpopup()
            }
            else {
              this._toastr.error('Something went wrong,please try again', 'Timesheet');
            }
          });
        }
        this.bsModalRef?.hide();
      });
    }
  }

  totalDurationSum: string;
  calculateDurationSum() {
    let totalMinutes = 0;
    for (const entry of this.loggedData) {
      if (entry.durationStr) {
        if (entry.durationStr.includes(':')) {
          const [hoursStr, minutesStr] = entry.durationStr.split(':');
          const hours = parseFloat(hoursStr) || 0;
          const minutes = parseFloat(minutesStr) || 0;
          totalMinutes += hours * 60 + minutes;
        } else if (entry.durationStr.includes('.')) {
          const decimalHours = parseFloat(entry.durationStr);
          const hours = Math.floor(decimalHours);
          const minutes = Math.round((decimalHours - hours) * 100);
          totalMinutes += hours * 60 + minutes;
        }
      }
    }
    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    this.totalDurationSum = `${totalHours}:${remainingMinutes.toString().padStart(2, '0')}`;
  }

  GetDailyTimeSheetData() {
    let date = this.datepipe.transform(this.timesheetdatePickerdefault, 'yyyy-MM-d')
    this._timesheetService.GetDailyTimesheetByUserSelection(date, this.userId).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
      if (response) {
        this.isUserAllowedToLog = response.isUserAllowedToLog;
        this.disableAddButton = !this.isUserAllowedToLog;
      }
      if (response?.lstDailyLogData?.length > 0) {
        this.loggedData = response.lstDailyLogData;
        this.calculateDurationSum();
      }
    });
  }

  onFieldChange() {
    const fieldsToCompare = [
      { current: this.quickAddSelectedTimesheetClient, original: this.originalSelectedTimesheetClient },
      { current: this.selectedTimesheetJob, original: this.originalSelectedTimesheetJob },
      { current: this.selectedTimesheetTask, original: this.originalSelectedTimesheetTask },
      { current: this.timesheetdatePickerdefault, original: this.originalTimesheetDatePicker },
      { current: this.startDateTime, original: this.originalStartDateTime },
      { current: Number(this.selectedUnitValue), original: this.originalSelectedUnitValue },
      { current: this.selectedDefaultRate, original: this.originalSelectedDefaultRate },
      { current: this.calculatedTime, original: this.originalCalculatedTime },
      { current: this.selectedComment || "", original: this.originalComment || "" }
    ];

    this.hasUnsavedChanges = fieldsToCompare.some(field => field.current !== field.original);
  }

  isFormValid(): boolean {
    const isLeaveItem = (this.selectedTimesheetJob === 0 && this.selectedTimesheetTask === 0) || this.selectedTimesheetClientID === 0;
    const unitCondition = this._timeSheetFormat
      ? (this.selectedUnitValue !== null && this.selectedUnitValue !== undefined && this.selectedUnitValue > 0)
      : true;
    const isValidRate = this.disableRate ? true : ![null, undefined, ''].includes(this.selectedDefaultRate);

    const isValid = !this._timeSheetlevel
      ? isLeaveItem
        ? Boolean(
          this.quickAddSelectedTimesheetClient &&
          this.timesheetdatePickerdefault &&
          unitCondition
        )
        : Boolean(
          this.selectedTimesheetTask &&
          this.quickAddSelectedTimesheetClient &&
          this.selectedTimesheetJob &&
          this.timesheetdatePickerdefault &&
          isValidRate &&
          unitCondition
        )
      : isLeaveItem
        ? Boolean(
          this.quickAddSelectedTimesheetClient &&
          this.timesheetdatePickerdefault &&
          unitCondition
        )
        : Boolean(
          this.quickAddSelectedTimesheetClient &&
          this.selectedTimesheetJob &&
          this.timesheetdatePickerdefault &&
          isValidRate &&
          unitCondition
        );

    return isValid && this.hasUnsavedChanges;

  }
  checkIfFutureDate() {
    const currentDate = new Date();
    const selectedDate = new Date(this.timesheetdatePickerdefault);
    this.isFutureDate = selectedDate > currentDate;
  }
  customClientSearch(term: string, item: any): boolean {

    if (!term) return true;

    const words = term.toLowerCase().trim().split(/\s+/);

    const text = (item.displayClientName || '').toLowerCase();

    return words.every(word => text.includes(word));
  }

  moveFocusToDescription(event: Event) {
    event.preventDefault();
    timer(200).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.descpquicktime.toArray()[0].nativeElement.focus();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  applyRateFilter() {
    const selectedDate = new Date(this.timesheetdatePickerdefault);
    selectedDate.setHours(0, 0, 0, 0);

    const filteredRates = (this.allRates || []).filter(rate => {

      const start = rate.billingStartDate ? new Date(rate.billingStartDate) : null;
      const end = rate.billingEndDate ? new Date(rate.billingEndDate) : null;

      if (start) start.setHours(0, 0, 0, 0);
      if (end) end.setHours(0, 0, 0, 0);


      if (!start && !end) return false;

      return (
        (!start || start <= selectedDate) &&
        (!end || end >= selectedDate)
      );
    });

    this.rateListData = filteredRates.map(i => {
      i.getLabel = this.currencyPipe.transform(i.billRate);
      return i;
    });

    this.userDefaultRate = this.rateListData.find(x => x.isDefault);

  }

  canShowEditDeleteContainer(data: any): boolean {
    return canShowEditDeleteContainerUtil(data);
  }

}

export interface BillRatesValues {
  billRateID: any
  description: any;
  billRate: any;
  isDefault: any;
}
